import * as http from '../../../vue_shared/http'
import { stringify } from '../../../vue_shared/query_params'

/* eslint-disable camelcase */
export interface CivicPlusPayParams {
  invoice_id: number | string
}

export interface CivicPlusPayData {
  redirect: string
}

export async function fetchCivicPlusPayData(
  params: CivicPlusPayParams
): Promise<CivicPlusPayData> {
  return http.get<CivicPlusPayData>(
    `/client/payments/civicplus_pay_hosted_form?${stringify(params)}`
  )
}
